import {Component, OnInit} from '@angular/core';
import {StepperService} from '../../../../projects/mydocma/import-export/src/lib/stepper/stepper.service';
import {stepperConfig} from '../config/export/stepper-config';
import {ExecutionService} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution.service';
import {ExecutionItem} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-item';
import {ExecutionStateEnum} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-state.enum';

@Component({
    selector: 'app-layouts',
    templateUrl: './export.component.html',
    styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {

    public executionItems = [
        new ExecutionItem({
            name: 'import',
            text: 'Export is in progress...',
            icon: 'done',
            progress: 30
        })
    ];

    public exportItems = [
        {firstName: 'Yura',	lastName: 'Gagarin', birth: '12.11.1993', age: 30, userName: 'qwert13', nationality: 'Ukrainian'},
        {firstName: 'Michael',	lastName: 'Peterson', birth: '11.11.1993', age:	25, userName: 'Resist223', nationality: 'Estonian'},
        {firstName: 'Kendrick',	lastName: 'Lamar', birth: '10.11.1993', age: 34, userName: 'tushe22', nationality: 'Mexican'},
        {firstName: 'Yulia',	lastName: 'Ovchinnikova', birth: '09.11.1993', age:	24, userName: 'okWithThat', nationality: 'Chinese'}
    ];

    constructor(
        public stepperService: StepperService,
        public executionService: ExecutionService
    ) {
        this.stepperService.init(stepperConfig, null, new Map());
    }

    public ngOnInit() {
        const stepDataMapping = this.stepperService.getStepByName('dataMapping');
        stepDataMapping.data = this.exportItems;

        setTimeout((step) => {
            step.component.enter();
        }, 1000, stepDataMapping);
    }

    public step2Init() {
        this.executionService.end();
    }

    public step2Start() {
        this.executionService.start(this.executionItems);
    }

    public step2SetImportProgress(type) {
        if (type === 'inProgress') {
            this.executionItems[0].text = 'Export is in progress...';
            this.executionItems[0].state = ExecutionStateEnum.Running;

            return;
        }
        if (type === 'done') {
            this.executionItems[0].text = 'Export was successful';
            this.executionItems[0].state = ExecutionStateEnum.Completed;

            return;
        }
    }
}

